import React, {SFC} from "react";
import "./SystemIcon.scss";

import {ReactComponent as arrowRightO} from "./svg/arrow-right-o.svg";
import {ReactComponent as arrowCircleS} from "./svg/close-circle-s.svg";
import {ReactComponent as closeSmallO} from "./svg/close-small-o.svg";
import {ReactComponent as markerMapS} from "./svg/marker-map-s.svg";
import {ReactComponent as timesCircleS} from "./svg/times-circle-s.svg";
import {ReactComponent as arrowLeftO} from "./svg/times-circle-s.svg";
import {ReactComponent as calendarS} from "./svg/arrow-left-o.svg";
import {ReactComponent as locatorS} from "./svg/locator-s.svg";
import {ReactComponent as parcelS} from "./svg/parcel-s.svg";
import {ReactComponent as tickO} from "./svg/tick-o.svg";
import {ReactComponent as pencilO} from "./svg/pencil-o.svg";
import {ReactComponent as radioCycleNormal} from "./svg/radio-cycle-normal.svg";
import {ReactComponent as radioCycleSelected} from "./svg/radio-cycle-selected.svg";
import {ReactComponent as account} from "./svg/account.svg";
import {ReactComponent as atl} from "./svg/atl.svg";
import {ReactComponent as date} from "./svg/date.svg";
import {ReactComponent as location} from "./svg/location.svg";
import {ReactComponent as parcel} from "./svg/parcel.svg";
import {ReactComponent as tickCircleS} from "./svg/tick-circle-s.svg";
import {ReactComponent as chevronDownO} from "./svg/chevron-down-o.svg";
import {ReactComponent as spinnerO} from "./svg/spinner-o.svg";
import {ReactComponent as bulbCircleS} from "./svg/bulb-circle-s.svg";

const svgs = {
  "arrow-right-o": arrowRightO,
  "close-circle-s": arrowCircleS,
  "close-small-o": closeSmallO,
  "marker-map-s": markerMapS,
  "times-circle-s": timesCircleS,
  "arrow-left-o": arrowLeftO,
  "calendar-s": calendarS,
  "locator-s": locatorS,
  "parcel-s": parcelS,
  "tick-o": tickO,
  "pencil-o": pencilO,
  "radio-cycle-normal": radioCycleNormal,
  "radio-cycle-selected": radioCycleSelected,
  "account": account,
  "atl": atl,
  "date": date,
  "location": location,
  "parcel": parcel,
  "tick-circle-s": tickCircleS,
  "chevron-down-o": chevronDownO,
  "spinner-o": spinnerO,
  "bulb-circle-s": bulbCircleS,
};

export type Props = {
  className?: string;
  name: string;
  [name: string]: any;
};

export const SystemIcon: SFC<Props> = ({className, name, ...rest}) => {
  let classNameStr = `system-icon autotest-system-icon-${name}`;

  if (className) {
    classNameStr += ` ${className}`;
  }

  const SvgIcon = svgs[name];

  return (
      <SvgIcon className={classNameStr} {...rest} />
  );
};

export default SystemIcon;


// WEBPACK FOOTER //
// ./src/components/lib/Icons/SystemIcon/SystemIcon.tsx